exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gap-1[data-v-7b5467d6] {\n\tgap: 5px;\n}\n.btn-close[data-v-7b5467d6] {\n\twidth: 100px !important;\n}\n.btn-confirm[data-v-7b5467d6] {\n\twidth: 100px !important;\n}\n", ""]);

// exports
